import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import Home from '@/views/Home.vue'
import Tutorial from '@/views/Tutorial.vue'
import Login from '@/components/Login.vue'
import Cambiar_clave from '@/components/Cambiar_clave.vue'
import Usuario from '@/components/admin/Usuario.vue'
import Cliente from '@/components/admin/Cliente.vue'
import Articulo from '@/components/admin/Articulo.vue'
import Albaran from '@/components/admin/Albaran.vue'
import Picking_y_packing from '@/components/admin/Picking_y_packing.vue'
import Cliente_articulo from '@/components/Cliente_articulo.vue'
import Cliente_picking_y_packing from '@/components/Cliente_picking_y_packing.vue'

Vue.use(VueRouter);


const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            administrador: true,
            almacenero: true,
            cliente_almacen: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            libre: true
        }
    },
    {
        path: '/cambiar_clave',
        name: 'cambiar_clave',
        component: Cambiar_clave,
        meta: {
            libre: true
        }
    },
    {
        path: '/admin/cliente',
        name: 'cliente',
        component: Cliente,
        meta: {
            administrador: true
        }
    },
    {
        path: '/admin/articulo',
        name: 'articulo',
        component: Articulo,
        meta: {
            administrador: true,
            almacenero: true
        }
    },
    {
        path: '/admin/albaran',
        name: 'albaran',
        component: Albaran,
        meta: {
            administrador: true,
            almacenero: true
        }
    },
    {
        path: '/admin/picking_y_packing',
        name: 'picking_y_packing',
        component: Picking_y_packing,
        meta: {
            administrador: true,
            almacenero: true
        }
    },
    {
        path: '/admin/usuario',
        name: 'usuario',
        component: Usuario,
        meta: {
            administrador: true
        }
    },
    {
        path: '/picking_y_packing',
        name: 'cliente_picking_y_packing',
        component: Cliente_picking_y_packing,
        meta: {
            cliente_almacen: true
        }
    },
    {
        path: '/articulo',
        name: 'cliente_articulo',
        component: Cliente_articulo,
        meta: {
            cliente_almacen: true
        }
    },
    {
        path: '/tutorial',
        name: 'tutorial',
        component: Tutorial,
        meta: {
            libre: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    console.log('beforeEach');
    console.log('to', to);
    console.log('to.name', to.name);
    console.log('from', from);
    console.log('next', next);
    if (store.state.usuario && (to.name == 'login')) {
        next({ name: 'home' });
    } else if (to.matched.some(record => record.meta.libre)) {
        console.log('meta.libre record');
        next();
    } else if (store.state.usuario && store.state.usuario.rol == 'Administrador') {
        console.log('Administrador');
        if (to.matched.some(record => record.meta.administrador)) {
            next();
        }
        console.log('No meta');
    } else if (store.state.usuario && store.state.usuario.rol == 'ClienteAlmacen') {
        console.log('ClienteAlmacen');
        if (to.matched.some(record => record.meta.cliente_almacen)) {
            next();
        }
        console.log('No meta');
    } else if (store.state.usuario && store.state.usuario.rol == 'Almacenero') {
        console.log('Almacenero');
        if (to.matched.some(record => record.meta.almacenero)) {
            next();
        }
        console.log('No meta');
    } else {
        console.log('login');
        next({ name: 'login' });
    }
});

export default router
